<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)">
		<div class="ld-panel-title">
			<h2 class="back-btn">参数管理</h2>
		</div>
		<div class="ld-panel-main">
			<el-button type="primary" class="add" @click="dialogGroupVisible = true">创建参数模板</el-button>
			<div class="search-main clear">
				<el-input v-model="searchInput" class="input" placeholder="请输入搜索内容..." clearable @clear="handleEmpty"></el-input>
				<span @click="searchClick" class="btn"></span>
			</div>
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column prop="template_id" label="模板ID" />
				<el-table-column prop="name"  label="模板名称" />
				<el-table-column prop="version" label="版本" width="150" />
				<el-table-column prop="template_type" label="模板类型" width="160" />
				<el-table-column prop="create_time" label="创建时间" width="200" />
				<el-table-column label="操作" width="170">
				  <template #default="scope">
					<el-button link type="primary" size="small" @click="rowOperation(scope.row,'detail')">查看详情</el-button>
					<el-button link type="primary" size="small" v-if="scope.row.template_type != '系统模板'" @click="rowOperation(scope.row,'edit')">编辑</el-button>
					<el-button link type="danger" size="small" v-if="scope.row.template_type != '系统模板'" @click="rowOperation(scope.row,'delete')">删除</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
		</div>
		<!-- 模板管理 -->
		<el-dialog width="900" :show-close="false" :close-on-click-modal="false" v-model="dialogGroupVisible" title="参数模板">
			<el-form :rules="rules" :model="groupForm" ref="ruleFormRef" :label-width="formLabelWidth">
				<el-form-item label="所属实例" prop="instance_id">
					<el-select v-model="groupForm.instance_id">
						<el-option v-for="item in exampleOptions" :key="item.instance_id" :value="item.instance_id" :label="item.instance_name +'('+item.instance_id+')'"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="版本类型" prop="version">
					<el-select v-model="groupForm.version">
						 <el-option v-for="item in versionOptions" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="模板名称" prop="name">
					<el-input v-model="groupForm.name" autocomplete="off" />
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetForm(ruleFormRef)">取消</el-button>
					<el-button type="primary" :disabled="submitDisabled" @click="submitForm(ruleFormRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted,nextTick } from 'vue';
	import { useRouter } from 'vue-router';
	import { getVersion } from '@/api/home';
	import { fetchExample } from '@/api/users';
	import { fetchList,listDelete,parAdd,parDetail } from '@/api/template';
	import pageList from '../../components/pageList.vue'
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const router = useRouter();
	const fullscreenLoading = ref(false);
	const submitDisabled = ref(false);
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const formLabelWidth = ref('160px')
	const loading = ref(true);
	const dialogGroupVisible = ref(false);
	const searchInput = ref('');
	const versionOptions = ref('');
	const exampleOptions = ref();
	const templateId = ref('');
	const tableData = ref();
	const gridData = ref();
	const ruleFormRef = ref(null);
	const groupForm = ref({name:'',version:'',instance_id:''})
	const rules = reactive({
		instance_id: [
			{ required: true, message: '请选择实例', trigger: 'blur' },
		],
		version: [
			{ required: true, message: '请选择版本类型', trigger: 'blur' },
		],
		name: [
			{ required: true, message: '请填写模板名称', trigger: 'blur' },
		]
	});
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'search':searchInput.value
		}
		fetchList(param).then((res) => {
			paginationTotal.value = res.data.count
			tableData.value = res.data.list
			loading.value = false
		})
		getVersion().then((res) => {
			versionOptions.value = res.data.map(item => ({ key: item, value: item }));
		});
		fetchExampleF()
	}
	const fetchExampleF = () => {
		const param = {'page':1,'size':9999}
		fetchExample(param).then((res) => {
			exampleOptions.value = res.data.list;
		})
	};
	const rowOperation = (row, now) => {
		if(now == 'detail'){
			router.push({ path: '/template/detail',query: { id: row.template_id} })
		}
		if(now == 'edit'){
			dialogGroupVisible.value = !dialogGroupVisible.value;
			nextTick(() => {
			    Object.assign(groupForm.value,row);
				const param = {'template_id':row.template_id}
				parDetail(param).then((res) => {
					gridData.value = res.data.details;
				});
			})
		}
		if(now == 'delete'){
			const param = {"template_id": row.template_id}
			ElMessageBox.confirm(
				'确定要删除该模板吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				listDelete(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	};
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				fullscreenLoading.value = true;
				const param = groupForm.value;
				submitDisabled.value = true;
				parAdd(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						resetForm()
						fetchListF();
					}
					fullscreenLoading.value = false;
					submitDisabled.value = false;
				})
			} else {
			  return false;
			}
		});
	};
	const resetForm = () => {
		groupForm.value = {name:'',version:'',instance_id:''};
		ruleFormRef.value.resetFields();
		dialogGroupVisible.value = !dialogGroupVisible.value;
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const searchClick = () => {
		fetchListF()
	};
	const handleEmpty = () => {
		fetchListF()
	};
	
	onMounted(() => {
		fetchListF()
	});
			
</script>

<style lang="scss" scoped>
	.search-main{float: right;}
</style>